import React from "react";
import { SearchIcon } from "./Icons";
import TodoItem from "./TodoItem";
import "./TodoList.css";

const FILTERS = ["all", "active", "done", "high", "medium", "low"];

export default function TodoList({ todos, done, search, filter, onSearch, onFilter, onToggle, onDelete, onEdit, onClearCompleted, categories }) {
  return (
    <>
      <div className="search-bar">
        <span className="search-icon"><SearchIcon/></span>
        <input
          type="text"
          placeholder="Search tasks..."
          value={search}
          onChange={e => onSearch(e.target.value)}
        />
      </div>

      <div className="filters">
        {FILTERS.map(f => (
          <button
            key={f}
            className={"filter-btn" + (filter === f ? " active" : "")}
            onClick={() => onFilter(f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {done > 0 && (
        <button className="clear-completed" onClick={onClearCompleted}>
          &#10005; Clear {done} completed
        </button>
      )}

      <div className="todo-list">
        {todos.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">&#10022;</div>
            <h3>Nothing here yet</h3>
            <p>Add your first task above to get started.</p>
          </div>
        ) : (
          todos.map(todo => (
            <TodoItem key={todo.id} todo={todo} onToggle={onToggle} onDelete={onDelete} onEdit={onEdit} categories={categories}/>
          ))
        )}
      </div>
    </>
  );
}
